/* biome-ignore-all lint/suspicious/noExplicitAny: legacy data structure */
import type { Response, CollectionResponse, PageQueryParams } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface UserSearchParams extends PageQueryParams {
  search?: string
  is_test?: number | string
  is_online?: string | boolean
}

export interface UserApiParams {
  page: number
  limit: number
  search?: string
  is_test?: number | string
  is_online?: string | boolean
}

export interface UserUpdateParams {
  id: number
  is_active?: number
  is_test?: number
}

export interface TempPasswordData {
  temp_password: string
  expires_in_seconds: number
  expires_at: string
}

export const userService = {
  list(params: UserApiParams) {
    return HttpRequest.get("v1/users", {
      searchParams: params as any,
    }).json<CollectionResponse>()
  },

  update(id: number, data: { is_active?: number; is_test?: number }) {
    return HttpRequest.put(`v1/users/${id}`, {
      json: data,
    }).json<Response>()
  },

  updateStatus(id: number, isActive: number) {
    return HttpRequest.put(`v1/users/${id}`, {
      json: { is_active: isActive },
    }).json<Response>()
  },

  getLearnedSets(userId: number | string, params?: any) {
    return HttpRequest.get(`v1/users/${userId}/learned-sets`, {
      searchParams: params as any,
    }).json<CollectionResponse>()
  },

  getTempPassword(userId: number | string) {
    return HttpRequest.get(`v1/users/${userId}/temp-password`).json<Response<TempPasswordData | null>>()
  },

  generateTempPassword(userId: number | string) {
    return HttpRequest.post(`v1/users/${userId}/temp-password`).json<Response<TempPasswordData>>()
  },

  revokeTempPassword(userId: number | string) {
    return HttpRequest.delete(`v1/users/${userId}/temp-password`).json<Response<null>>()
  },
}
